import i18n from '@/i18n'
import store from '@/store'
import axios from 'axios'

const guard = async (to, from, next) => {
  const language = to.params.lang || localStorage.getItem('lang') || to.meta.langDefault
  const document = to.params.doc || to.meta.docDefault

  await latestVersionFetch()
  const version = to.params.version || store.state.global.latestVersion

  const paramsPath = `/${language}/${document}/${version}`
  if (!to.params.lang || !to.params.doc || !to.params.version) {
    i18n.locale = language
    localStorage.setItem('lang', language)
    window.location = paramsPath
    return
  }

  if (i18n.locale !== language) {
    i18n.locale = language
    localStorage.setItem('lang', language)
  }
  next()
}

const latestVersionFetch = () => {
  const api = process.env.VUE_APP_API
  const url = `${api}/latest.json`

  store.commit('global/SET_LOADING', true)

  return axios
    .get(url)
    .then(response => {
      const { version } = response.data

      store.commit('global/SET_LATEST_VERSION', version)
      store.commit('global/SET_LOADING', false)

      return version
    })
    .catch(error => {
      throw error
    })
}

export default guard
